<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentArticleCategory.attributes"
          headline="Edit Content Article Category"
          :errors="errors"
          :edit="true"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentArticleCategories/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentArticleCategory: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-article-categories/' + this.$route.params.contentArticleCategoryId).then(response => {
        this.contentArticleCategory = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-article-categories/' + this.$route.params.contentArticleCategoryId, data)
          .then(response => {
            notify.success('The content article category was saved')

            this.contentArticleCategory = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
